import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Spinner } from "react-bootstrap";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import TextInput from "../../../components/forms/TextInput";
import { validationMode } from "../../../config/helpers";
import { IFormInscription } from "./types";

interface IProps {
  formMethods: UseFormReturn<IFormInscription>;
  emailExists: boolean;
  compteActif: boolean;
  emailValidated: boolean;
  showCodeVerification: boolean;
  isSubmitting: boolean;
  onModifier: () => void;
}

const CpntEmailVerification: React.FC<IProps> = ({
  formMethods,
  emailExists,
  compteActif,
  emailValidated,
  showCodeVerification,
  isSubmitting,
  onModifier,
}) => {
  const { formState } = formMethods;

  return (
    <>
      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <label>
            E-mail <span className="text-danger">*</span>{" "}
            {(emailExists || emailValidated || showCodeVerification) && (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onModifier();
                }}
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: "0.9em",
                  color: "#6c757d",
                }}
              >
                (modifier)
              </a>
            )}
          </label>
        </div>
        <TextInput
          label=""
          formName="Email"
          ismandatory={true}
          validationStyle={validationMode.classic}
          placeholder="email"
          disabled={emailExists || emailValidated || showCodeVerification}
        />
        {emailExists && !compteActif && (
          <div className="info-card-body mt-2">
            Votre compte est en attente de validation de votre part.
            <br />
            Merci de vérifier votre boite email.
          </div>
        )}
      </CpntFormSectionContainer>

      {!emailValidated && !showCodeVerification && (
        <CpntFormSectionNavigation>
          {isSubmitting ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            <button
              type="submit"
              className="btn btn-primary col-12"
              disabled={!formState.isValid || emailExists}
            >
              Valider
            </button>
          )}
        </CpntFormSectionNavigation>
      )}
    </>
  );
};

export default CpntEmailVerification;
